// extracted by mini-css-extract-plugin
export default {"imageWrapper":"KJ-z","twoColumnImage":"LJ-z"};